<!-- 销售出入库管理 -->
<template>
    <div class="container">
        <div class="header">
            <Input
                class="mr24 mb24 w300"
                type="text"
                v-model="storePrams.keywords"
                placeholder="请输入单号/产品码编码/操作说明/操作员关键词"
            ></Input>
            <Select
                class="mr24 mb24 w200"
                v-model="storePrams.logistics_company_id"
                clearable
                filterable
                placeholder="请选择承运物流,支持搜索"
            >
                <Option
                    v-for="item in logisticsList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                >
            </Select>
            <Select
                class="mr24 mb24 w200"
                v-model="storePrams.store_id"
                clearable
                filterable
                placeholder="请选择收货门店名称"
            >
                <Option
                    v-for="item in storeList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                >
            </Select>
            <DatePicker
                class="mr24 mb24 w200"
                type="daterange"
                split-panels
                placement="bottom-start"
                placeholder="选择时间段"
                separator=" 至 "
                @on-change="changeDate"
            ></DatePicker>
            <Select
                class="mr24 mb24 w200"
                v-model="storePrams.agent_id"
                clearable
                filterable
                placeholder="请选择发货的代理名称"
            >
                <Option
                    v-for="item in agentList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.agent_name }}</Option
                >
            </Select>
            <Select
                class="mr24 mb24 w200"
                v-model="storePrams.shipper_type"
                clearable
                filterable
                placeholder="请选择发货类型"
            >
                <Option
                    v-for="item in typeList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                >
            </Select>
            <Input
                class="mr24 mb24 w200"
                type="text"
                v-model="storePrams.logistics_number"
                placeholder="请输入物流单号"
            ></Input>
            <Button
                class="theme-bc mb24 theme-default-color"
                icon="ios-search"
                @click="goSearch"
                >确认搜索</Button
            >
        </div>
        <div class="content">
            <div>
                <div v-if="lists.length">
                    <div v-for="(item, index) of lists" :key="index">
                        <div class="div-box">
                            <div class="box-header flex-sb">
                                <div>
                                    <span>订单编号：{{ item.order_no }}</span>
                                    <Button
                                        class="ml12"
                                        v-if="item.shipper_type == 1"
                                        type="success"
                                        >发货给代理商</Button
                                    >
                                    <Button
                                        class="ml12"
                                        v-if="item.shipper_type == 2"
                                        type="success"
                                        >发货给门店</Button
                                    >
                                    <Button
                                        class="ml12"
                                        v-if="item.shipper_type == 3"
                                        type="success"
                                        >零售出库</Button
                                    >
                                    <Button
                                        class="ml12"
                                        v-if="item.shipper_type == 4"
                                        >退给代理商</Button
                                    >
                                    <Button
                                        class="ml12"
                                        v-if="item.shipper_type == 5"
                                        >退给门店</Button
                                    >
                                    <Button
                                        class="ml12"
                                        v-if="item.shipper_type == 6"
                                        >退回总部</Button
                                    >
                                </div>
                                <div>发货时间：{{ item.logistics_time }}</div>
                            </div>
                            <div class="box-content flex-sb">
                                <template v-if="item.incoming_qrcode[0]">
                                    <img
                                        class="wh60"
                                        v-if="item.incoming_qrcode[0].product"
                                        :src="
                                            item.incoming_qrcode[0].product
                                                .show_product_imgs[0]
                                        "
                                    />
                                </template>
                                <img
                                    class="wh60"
                                    v-else
                                    src="../../assets/example.png"
                                />
                                <div>
                                    <div v-if="item.incoming_qrcode[0]">
                                        {{
                                            item.incoming_qrcode[0].product
                                                ? item.incoming_qrcode[0]
                                                      .product.product_name
                                                : ""
                                        }}
                                    </div>
                                    <div>
                                        共计<span class="theme-color">{{
                                            item.incoming_qrcode_count
                                        }}</span
                                        >个溯源码
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        发货方: {{ item.from_type_text }}
                                        <template
                                            v-if="
                                                item.from_type == 2 ||
                                                item.from_type == 3
                                            "
                                        >
                                            <span v-if="item.from_type == 2"
                                                >({{
                                                    item.from_agent
                                                        ? item.from_agent
                                                              .agent_name
                                                        : ""
                                                }})</span
                                            >
                                            <span
                                                v-else-if="item.from_type == 3"
                                                >({{
                                                    item.from_store
                                                        ? item.from_store.name
                                                        : ""
                                                }})</span
                                            >
                                        </template>
                                    </div>
                                    <div>
                                        收货方:
                                        <span style="margin-right: 6px">{{
                                            item.shipper_type_text
                                        }}</span>
                                        <template
                                            v-if="
                                                item.shipper_type == 1 ||
                                                item.shipper_type == 4
                                            "
                                        >
                                            {{
                                                item.agent
                                                    ? item.agent.agent_name
                                                    : ""
                                            }}
                                        </template>
                                        <template
                                            v-if="
                                                item.shipper_type == 2 ||
                                                item.shipper_type == 5
                                            "
                                        >
                                            {{
                                                item.store
                                                    ? item.store.name
                                                    : ""
                                            }}
                                        </template>
                                    </div>
                                </div>
                                <div
                                    v-if="item.status == 1"
                                    style="color: #53c41a"
                                >
                                    <Icon
                                        type="ios-checkmark-circle-outline"
                                        color="#53C41A"
                                    />已完成
                                </div>
                                <div
                                    v-if="item.status == 2"
                                    style="color: #ff4838"
                                >
                                    <Icon
                                        type="ios-close-circle-outline"
                                        color="#FF4838"
                                    />失败
                                </div>
                                <div>
                                    <Button
                                        v-if="item.status == 1"
                                        type="primary"
                                        ghost
                                        @click="goBack(item)"
                                        >退回</Button
                                    >
                                    <Button
                                        class="ml12"
                                        v-if="item.status == 1"
                                        type="success"
                                        ghost
                                        @click="goInfo(item)"
                                        >录入物流信息</Button
                                    >
                                    <Button
                                        class="ml12"
                                        type="success"
                                        ghost
                                        @click="goDrawer(item)"
                                        >详情</Button
                                    >
                                    <Button
                                        class="ml12"
                                        type="error"
                                        ghost
                                        @click="goDel(1, item)"
                                        >删除</Button
                                    >
                                </div>
                            </div>
                            <div class="box-footer flex-sb">
                                <div>备注说明：{{ item.reason }}</div>
                                <div>创建时间：{{ item.created_at }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="none-div" v-else>
                    <img src="../../assets/none_background.png" />
                    <div>暂无数据~</div>
                </div>
            </div>
            <div class="page" v-if="lists.length != 0">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 详情 -->
        <Drawer v-model="drawers" :title="drawerTitle" width="80">
            <div>
                <div class="drawer-div">
                    <div class="drawer-box">
                        <div>
                            单据编号: {{ formData.order_no }}
                            <Button
                                class="ml12"
                                v-if="formData.shipper_type == 1"
                                type="success"
                                >发货给代理商</Button
                            >
                            <Button
                                class="ml12"
                                v-if="formData.shipper_type == 2"
                                type="success"
                                >发货给门店</Button
                            >
                            <Button
                                class="ml12"
                                v-if="formData.shipper_type == 3"
                                type="success"
                                >零售出库</Button
                            >
                            <Button
                                class="ml12"
                                v-if="formData.shipper_type == 4"
                                >退给代理商</Button
                            >
                            <Button
                                class="ml12"
                                v-if="formData.shipper_type == 5"
                                >退给门店</Button
                            >
                            <Button
                                class="ml12"
                                v-if="formData.shipper_type == 6"
                                >退回总部</Button
                            >
                        </div>
                        <div>发货单位: {{ formData.from_type_text }}</div>
                        <div>
                            收货单位:
                            <span style="margin-right: 6px">{{
                                formData.shipper_type_text
                            }}</span>
                            <template
                                v-if="
                                    formData.shipper_type == 1 ||
                                    formData.shipper_type == 4
                                "
                            >
                                {{
                                    formData.agent
                                        ? formData.agent.agent_name
                                        : ""
                                }}
                            </template>
                            <template
                                v-if="
                                    formData.shipper_type == 2 ||
                                    formData.shipper_type == 5
                                "
                            >
                                {{ formData.store ? formData.store.name : "" }}
                            </template>
                        </div>
                        <div>发货时间: {{ formData.logistics_time }}</div>
                        <div>创建时间: {{ formData.created_at }}</div>
                        <div>
                            操作人员:
                            {{
                                formData.operator ? formData.operator.user : ""
                            }}
                        </div>
                        <div>备注说明: {{ formData.reason }}</div>
                    </div>
                    <div class="complete-div">
                        <Icon
                            type="ios-checkmark-circle-outline"
                            color="53C41A"
                            size="38"
                        />
                        <span class="ml12">已完成</span>
                    </div>
                </div>
                <Table :columns="columnsDrawer" :data="dataDrawer" border>
                    <template slot-scope="{ row }" slot="show_product_imgs">
                        <div class="flex-c">
                            <img
                                class="wh60 mt12 mb12"
                                v-if="row.product"
                                :src="row.product.show_product_imgs[0]"
                            />
                            <img
                                class="wh60 mt12 mb12"
                                v-else
                                src="../../assets/example.png"
                            />
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="product_name">
                        <div>
                            {{ row.product ? row.product.product_name : "" }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="specs">
                        <div>{{ row.product ? row.product.specs : "" }}</div>
                    </template>
                </Table>
                <div class="page">
                    <Page
                        :current="pageDrawer.page"
                        :page-size="pageDrawer.limit"
                        :total="totalDrawer"
                        show-elevator
                        show-total
                        @on-change="pageDrawerChange"
                    />
                </div>
            </div>
        </Drawer>
        <!-- 录入物流信息 -->
        <Modal
            v-model="infoModal"
            title="录入物流信息"
            width="70"
            :mask-closable="false"
        >
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    @click="goModal"
                    >新增流程和物流信息</Button
                >
                <Table :columns="columnsInfo" :data="dataInfo" border>
                    <template slot-scope="{ row }" slot="start">
                        <div v-if="row.start">
                            {{ row.start }} - {{ row.end }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="code">
                        <div>{{ row.code[0] }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="success" ghost @click="goModal(row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(2, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
                <div class="page">
                    <Page
                        :current="pageInfo.page"
                        :page-size="pageInfo.limit"
                        :total="totalInfo"
                        show-elevator
                        show-total
                        @on-change="pageInfoChange"
                    />
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 新增/编辑 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            width="700"
            :mask-closable="false"
        >
            <div>
                <div class="modal-div">
                    <img
                        class="wh24 mr12"
                        src="../../assets/information.png"
                    />
                    <div>
                        <div>
                            不填写“溯源码”或“ID号段”则代表所有的产品都是同一条物流信息。
                        </div>
                        <div>
                            同一溯源码编码多次录入物流信息，则自动覆盖上一条物流信息，保留最后一次录入的物流信息
                        </div>
                    </div>
                </div>
                <Form
                    :model="formItem"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="物流公司：">
                        <Select
                            class="w300"
                            v-model="formItem.logistics_company_id"
                            clearable
                            filterable
                            placeholder="请选择物流公司"
                            :label-in-value="true"
                            @on-change="changeLogistics"
                        >
                            <Option
                                v-for="item in logisticsList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.name }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem label="物流单号：">
                        <Input
                            class="w300"
                            type="text"
                            v-model="formItem.logistics_number"
                            placeholder="请输入物流单号"
                        ></Input>
                    </FormItem>
                    <FormItem v-if="modalID == 1" label="选择条件：">
                        <RadioGroup v-model="formItem.type" type="button">
                            <Radio label="1">录入码数据</Radio>
                            <Radio class="mr24 ml24" label="2">按ID号段</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem
                        v-if="modalID == 1 && formItem.type == '1'"
                        label="溯源码："
                    >
                        <Input
                            class="w500"
                            type="textarea"
                            v-model="code"
                            :autosize="{ minRows: 6 }"
                            placeholder="一行一个，支持手工录入和扫码枪扫码录入 可以同时录入产品码，小箱码，大箱码 系统会智能分析查询匹配，自动批量智能处理。"
                        ></Input>
                    </FormItem>
                    <FormItem
                        v-if="modalID == 1 && formItem.type == '2'"
                        label="ID号段："
                    >
                        <Input
                            class="width100"
                            type="text"
                            v-model="formItem.start"
                            placeholder="请输入起始ID"
                        ></Input>
                        <span class="mr12 ml12">---</span>
                        <Input
                            class="width100"
                            type="text"
                            v-model="formItem.end"
                            placeholder="请输入截止ID"
                        ></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelForm">取消</Button>
                <Button
                    class="theme-bc ml24 theme-default-color"
                    @click="submitForm"
                    >确定</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    incoming_list,
    incoming_delete,
    incoming_info,
    incoming_back,
    incoming_logistics,
    incoming_logistics_del,
    incoming_enter,
    incoming_select,
    store_select,
    agent_select,
} from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
                keywords: "",
                logistics_company_id: "",
                store_id: "",
                agent_id: "",
                start_date: "",
                end_date: "",
                shipper_type: "",
                logistics_number: "",
            },
            total: 0,
            logisticsList: [],
            storeList: [],
            agentList: [],
            typeList: [
                { id: 1, name: "发货给代理商" },
                { id: 2, name: "发货给门店" },
                { id: 3, name: "零售出库" },
                { id: 4, name: "退给代理商" },
                { id: 5, name: "退给门店" },
                { id: 6, name: "退回总部" },
            ],
            lists: [],
            drawers: false,
            drawerTitle: "",
            pageDrawer: {
                id: "",
                page: 1,
                limit: 10,
            },
            totalDrawer: 0,
            columnsDrawer: [
                { type: "index", width: 60, align: "center" },
                {
                    title: "产品图片",
                    slot: "show_product_imgs",
                    align: "center",
                },
                { title: "产品名称", slot: "product_name", align: "center" },
                { title: "规格", slot: "specs", align: "center" },
                { title: "产品编码", key: "qrcode_number", align: "center" },
            ],
            dataDrawer: [],
            formData: {},
            infoModal: false,
            pageInfo: {
                id: "",
                page: 1,
                limit: 10,
            },
            totalInfo: 0,
            columnsInfo: [
                { type: "index", width: 60, align: "center" },
                { title: "ID号段", slot: "start", align: "center" },
                { title: "溯源码", slot: "code", align: "center" },
                { title: "物流公司", key: "logistics", align: "center" },
                { title: "物流单号", key: "logistics_number", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataInfo: [],
            modals: false,
            modalTitle: "",
            modalID: "",
            formItem: {
                id: "",
                incoming_outgoing_id: "",
                logistics: "",
                logistics_number: "",
                type: "1",
                start: "",
                end: "",
                code: [],
                logistics_company_id: "",
            },
            code: "",
        };
    },
    mounted() {
        this.getList();
        this.getIncomingSelect();
        this.getStoreSelect();
        this.getAgentSelect();
    },
    methods: {
        getList() {
            incoming_list(this.storePrams)
                .then((res) => {
                    this.lists = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        pageDrawerChange(index) {
            this.pageDrawer.page = index;
            this.getIncomingInfo();
        },
        pageInfoChange(index) {
            this.pageInfo.page = index;
            this.getIncomingLogistics();
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        getIncomingSelect() {
            incoming_select()
                .then((res) => {
                    this.logisticsList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getStoreSelect() {
            store_select()
                .then((res) => {
                    this.storeList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getAgentSelect() {
            agent_select()
                .then((res) => {
                    this.agentList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        changeDate(e) {
            if (e[0]) {
                this.storePrams.start_date = e[0];
                this.storePrams.end_date = e[1];
            } else {
                this.storePrams.start_date = "";
                this.storePrams.end_date = "";
            }
        },
        // 记录详情里的商品溯源码列表
        getIncomingInfo() {
            incoming_info(this.pageDrawer)
                .then((res) => {
                    this.dataDrawer = res.data.data;
                    this.totalDrawer = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goDrawer(row) {
            this.drawerTitle =
                "查看单据为【" + row.order_no + "】的发货或退货记录详情";
            this.formData = row;
            this.pageDrawer.id = row.id;
            this.getIncomingInfo();
            setTimeout(() => {
                this.drawers = true;
            }, 300);
        },
        // 退回
        goBack(row) {
            this.$Modal.confirm({
                title: "退回提示",
                content: "确认退回吗？一经退回无法复原",
                onOk: () => {
                    incoming_back({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        goDel(index, row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 1) {
                        incoming_delete({ id: row.id })
                            .then((res) => {
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                    if (index == 2) {
                        incoming_logistics_del({ id: row.id })
                            .then((res) => {
                                this.getIncomingLogistics();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                },
                onCancel: () => {},
            });
        },
        goInfo(row) {
            this.pageInfo.id = row.id;
            this.getIncomingLogistics();
            this.formItem.incoming_outgoing_id = row.id;
            setTimeout(() => {
                this.infoModal = true;
            }, 300);
        },
        // 物流列表
        getIncomingLogistics() {
            incoming_logistics(this.pageInfo)
                .then((res) => {
                    this.dataInfo = res.data.data;
                    this.totalInfo = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goModal(row) {
            if (row.id) {
                this.modalID = 0;
                this.modalTitle = "编辑流程和物流信息";
                this.formItem.id = row.id;
                this.formItem.logistics = row.logistics;
                this.formItem.logistics_number = row.logistics_number;
                this.formItem.logistics_company_id = row.logistics_company_id;
                this.formItem.type = row.type + "";
                this.formItem.start = row.start;
                this.formItem.end = row.end;
            } else {
                this.modalID = 1;
                this.modalTitle = "新增流程和物流信息";
                this.formItem.id = "";
                this.formItem.logistics = "";
                this.formItem.logistics_number = "";
                this.formItem.type = "1";
                this.formItem.start = "";
                this.formItem.end = "";
                this.formItem.code = [];
                this.formItem.logistics_company_id = "";
                this.code = "";
            }
            this.modals = true;
        },
        cancelForm() {
            this.modals = false;
        },
        changeLogistics(e) {
            if (e) {
                this.formItem.logistics_company_id = e.value;
                this.formItem.logistics = e.label;
            } else {
                this.formItem.logistics_company_id = "";
                this.formItem.logistics = "";
            }
        },
        // 确定（提交表单）
        submitForm() {
            if (this.code) {
                this.formItem.code = this.code
                    .split("\n")
                    .map((item, index) => {
                        if (item === "") {
                            // 如果是空字符串，表示这里有一个换行
                            return null;
                        }
                        return item;
                    });
            }
            this.formItem.code = this.formItem.code.filter(
                (item) => item != null
            );
            incoming_enter(this.formItem)
                .then((res) => {
                    this.getIncomingLogistics();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.div-box {
    margin: 0 0 12px 0;
    background: #ffffff;
    border-radius: 5px;
    border: 1px solid #eaeaea;
}
.box-header {
    padding: 12px;
    background: #f7f7f7;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
    border-radius: 5px 5px 0px 0px;
}
.box-content {
    padding: 12px;
    background: rgba(247, 247, 247, 0);
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
    font-weight: 400;
    font-size: 14px;
    color: #747b95;
}
.box-footer {
    padding: 12px;
    background: rgba(247, 247, 247, 0);
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
    border-radius: 0px 0px 5px 5px;
}
.wh60 {
    width: 60px;
    height: 60px;
}
.none-div {
    text-align: center;
    color: #999;
}
.drawer-div {
    margin: 0 12px 12px 12px;
    display: flex;
    justify-content: space-between;
}
.drawer-box {
    font-size: 15px;
    color: #484e66;
    font-weight: 500;
}
.complete-div {
    font-size: 26px;
    color: #53c41a;
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.modal-div {
    padding: 24px;
    margin-bottom: 12px;
    background: rgba(255, 118, 29, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
}
.wh24 {
    width: 24px;
    height: 24px;
}
.w500 {
    width: 500px;
}
.width100 {
    width: 100px;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53c41a;
    border-color: #53c41a;
    box-shadow: -1px 0 0 0 #53c41a;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>